import { __awaiter } from "tslib";
import LocalServer from '../common/local-server-api';
const API_PATH = {
    REPORT: '/local-edit/report',
};
class MegaReportService {
    constructor() {
        this.version = 1;
        // apis 类接口因是 broker 上直接取值，如果包含内部调用需 arrow function 防止作用域错误
        this.apis = ['reportPerformance'];
        this.reportPerformance = (options) => __awaiter(this, void 0, void 0, function* () {
            void this.localServer.post(API_PATH.REPORT, options);
        });
        this.localServer = new LocalServer();
    }
}
export default MegaReportService;
//# sourceMappingURL=mega-report-service.js.map